import BaseMystery from '../BaseMystery'

const ThirdSorrowfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bartolom/fra/christ_t.jpg",
		"https://www.wga.hu/art/b/bosch/5panels/12thorns.jpg",
		"https://www.wga.hu/art/b/bosch/5panels/18mocked.jpg",
		"https://www.wga.hu/art/b/botticel/91late/08christ.jpg",
		"https://www.wga.hu/art/c/caravagg/07/38crowni.jpg",
		"https://www.wga.hu/art/c/caravagg/12/87crowni.jpg",
		"https://www.wga.hu/art/c/carracci/annibale/1/thorns.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_e/05/49religi.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/verso_2/verso17.jpg",
		"https://www.wga.hu/art/d/dyck_van/3other/crowning.jpg",
		"https://www.wga.hu/art/f/frueauf/elder/christ_c.jpg",
		"https://www.wga.hu/art/g/guercino/0/christ.jpg",
		"https://www.wga.hu/art/g/guggenbi/mondsee3.jpg",
		"https://www.wga.hu/art/j/janssen/thorns1.jpg",
		"https://www.wga.hu/art/j/janssen/thorns2.jpg",
		"https://www.wga.hu/art/o/oost/elder/thorns.jpg",
		"https://www.wga.hu/art/r/romanino/cremona2.jpg",
		"https://www.wga.hu/art/t/terbrugg/1/crowning.jpg",
		"https://www.wga.hu/art/t/tiziano/04_1540s/1crownin.jpg",
		"https://www.wga.hu/art/t/tiziano/07_1570s/08crowni.jpg",
		"https://www.wga.hu/art/v/valentin/crowning.jpg",
	];

	const scriptureQuote = "Weaving a crown out of thorns, they placed it on his head, and a reed in his right hand. And kneeling before him, they mocked him, saying, \"Hail, King of the Jews!\"";
	const scriptureCitation = "Matthew 27:29 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Matt%2027%3A28-30%3B%20John%2019%3A4-6&version=NABRE";

	return (
		<BaseMystery titleText="The Crowning with Thorns"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default ThirdSorrowfulMystery;